import Item from './Item';

export default Item;



// WEBPACK FOOTER //
// ./src/components/Buildings/List/Item/index.js